export const listAnnounce = async apiCall => {
  return await apiCall(`/announce/list`, "GET");
};

export const getAnnounce = async (apiCall, id) => {
  return await apiCall(`/announce/getDetail?id=${id}`, "GET");
};

export const upsertAnnounce = async (apiCall, id, title, content) => {
  const request = { id, title, content };
  return await apiCall("/announce/upsert", "POST", request);
};

export const deleteAnnounce = async (apiCall, id) => {
  const request = { id };
  return await apiCall("/announce/delete", "POST", request);
};
